export default "__VITE_ASSET__Bcz5vwDL__"